import { baseURL } from "./httpInstance";
import http from "./httpInstance";
import {
  getAccessToken,
  persistAuthFromResponse,
  clearAuthTokens,
} from "./tokenStorage";

export default class AuthService {
  constructor() {
    this.fetch = this.fetch.bind(this);
    this.login = this.login.bind(this);
    this.getProfile = this.getProfile.bind(this);
  }

  register(request) {
    const data = request.data;
    const params = request.params;

    return http("users/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
      params,
    }).then((res) => {
      // Registration usually does not return JWT; when it does, persist pair.
      persistAuthFromResponse(res);
      return Promise.resolve(res);
    });
  }

  login(username, password) {
    return http("token/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        username: username,
        password: password,
      },
    }).then((res) => {
      persistAuthFromResponse(res);
      return Promise.resolve(res);
    });
  }

  loggedIn() {
    return new Promise((resolve, _reject) => {
      const token = getAccessToken();
      if (token) {
        return resolve(true);
      }

      const profile = this.getProfile();
      if (profile) {
        return resolve(true);
      }

      return resolve(false);
    });
  }

  logout() {
    clearAuthTokens();
    localStorage.removeItem("profile");

    http("admin/logout/", {
      method: "GET",
      headers: {
        "content-type": "text/html",
      },
    })
      .then((_response) => {
        console.log("logout");
      })
      .catch(() => {
        // Best-effort logout: local auth state is already cleared.
      });
  }

  setProfile(profile) {
    localStorage.setItem("profile", JSON.stringify(profile));
  }

  getProfile() {
    const profile = localStorage.getItem("profile", null);
    if (profile) {
      return JSON.parse(profile);
    }
    return null;
  }

  _checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      throw response;
    }
  }

  fetch(url, options) {
    const headers = {
      ...options.headers,
    };

    return this.loggedIn().then((response) => {
      if (response) {
        const t = getAccessToken();
        if (t) {
          headers["Authorization"] = `JWT ${t}`;
        }
      }
      return fetch(baseURL + url, {
        ...options,
        headers,
      })
        .then(this._checkStatus)
        .then((response) => response.json());
    });
  }
}

export function authHeader() {
  const token = getAccessToken();
  if (token) {
    return {
      authorization: `JWT ${token}`,
    };
  }
}
